/** The five contracted phases. Phase 1 is built; later phases render as disabled markers. */
export type Phase = 'P1' | 'P2' | 'P3' | 'P4' | 'P5';

export const PHASE_NAME: Record<Phase, string> = {
  P1: 'Working product',
  P2: 'Live consultation',
  P3: 'Physician portal & earnings',
  P4: 'Case channel & rotation',
  P5: 'Administration & insight',
};

export const BUILT_PHASES: readonly Phase[] = ['P1'];

export function isBuilt(phase: Phase): boolean {
  return BUILT_PHASES.includes(phase);
}
